import { axios } from '@util';

class FCPUpload {
  async getFCPUploads(params = {}) {
    return await axios({
      url: '/fcp/upload/list',
      params: params,
    });
  }

  async createFCPUpload(formData = {}) {
    return await axios({
      url: '/fcp/upload/',
      method: 'POST',
      data: formData,
    });
  }

  async readFCPUpload(fileUniqueId, fileName) {
    return await axios({
      url: '/fcp/upload/file/preview/',
      method: 'POST',
      data: {
        file_unique_id: fileUniqueId,
        file_name: fileName,
      },
    });
  }
}

export default new FCPUpload();
